const LeftNavigationArrow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="37px"
    height="37px"
    fill="none"
    viewBox="0 0 37 37"
  >
    <circle cx="18.301" cy="18.301" r="18.301" fill="#fff"></circle>
    <path
      fill="#646464"
      style={{ filter: "brightness(0.4)" }}
      d="M11.66 17.796a.763.763 0 0 0 0 1.078l4.315 4.314a.762.762 0 1 0 1.078-1.078l-3.012-3.012h10.098a.763.763 0 1 0 0-1.525H14.041l3.012-3.013a.762.762 0 0 0-1.078-1.078z"
    ></path>
  </svg>
);

export default LeftNavigationArrow;
